import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";

function Analytics() {
  const location = useLocation();
  useEffect(() => {
    if (AB && AB.DATALAYER && typeof AB.DATALAYER.initHelpCenterPages === 'function') {
      AB.DATALAYER.initHelpCenterPages(location.pathname);
    }
  }, [location]);

  return null;
};

export default Analytics;
